import { executeReport, REPORT_TYPES } from '../../../../../../../../logic/utils/reportRequest';

export default async function SqlQuery(startTime, endTime) {
  return executeReport(REPORT_TYPES.MARK_REPORT, { startTime, endTime });
}
